import {Component, Input, OnInit} from '@angular/core';
import {ModalFunctionConfiguration, ModalTextConfiguration} from "../../interfaces/modal-configuration-interface";
import {ModalRoleEnum} from "../../enums/modal-enum";
import {FormGroup} from "@angular/forms";
import { IonToolbar, IonTitle, IonLabel, IonGrid, IonRow, IonCol, IonButton, ModalController } from '@ionic/angular/standalone';
import { UpperCasePipe } from '@angular/common';
import { TranslocoModule, TranslocoService, provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'app-error-request-modal',
    templateUrl: './error-request-modal.component.html',
    styleUrls: ['./error-request-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonGrid, IonRow, IonCol, IonButton, UpperCasePipe, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class ErrorRequestModalComponent  implements OnInit {
  private confirmButtonTextOverride: string | null = null;
  private cancelButtonTextOverride: string | null = null;
  modalMessage: string = '';
  confirmFunction: () => void;
  cancelFunction: () => void;

  get modalTitle(): string {
    return this.transloco.translate('shared.error_request.title');
  }

  get confirmButtonText(): string {
    return this.confirmButtonTextOverride ?? this.transloco.translate('common.action.confirm');
  }

  get cancelButtonText(): string {
    return this.cancelButtonTextOverride ?? this.transloco.translate('shared.error_request.cancel');
  }

  @Input() set text(text: ModalTextConfiguration) {
    this.modalMessage = text?.modal_message ?? '';
    this.confirmButtonTextOverride = text?.confirm_button ?? null;
    this.cancelButtonTextOverride = text?.cancel_button ?? null;
  }

  @Input() set functions(functions: ModalFunctionConfiguration) {
    if(!!functions.confirm_function) {
      this.confirmFunction = functions.confirm_function
    } else {
      this.confirmFunction = this.confirm
    }
    if(!!functions.cancel_function) {
      this.cancelFunction = functions.cancel_function
    } else {
      this.cancelFunction = this.cancel
    }

  }

  constructor(private modalController: ModalController,
              private transloco: TranslocoService,) {
    this.confirmFunction = this.confirm;
    this.cancelFunction = this.cancel;
  }

  ngOnInit() {}

  cancel() {
    return this.modalController.dismiss(ModalRoleEnum.CANCEL, ModalRoleEnum.CANCEL);
  }

  confirm() {
    return this.modalController.dismiss(null, ModalRoleEnum.CONFIRM);
  }
}
